module.exports = __webpack_public_path__ + "img/9788996103110.8b20046f.jpg";